
import { APIData } from '../constants';
import useRest from './base/useRest';

// USERS


const preffix = "users";

export const useUser = (options?: APIData) => {
    return useRest(`${preffix}`, options);
};

export const useUserBusiness = (options?: APIData) => {
    return useRest(`${preffix}/business`, options);
};
/*
export const useUserId =  (options:APIData) => {
    return useRest(`user/id/${options.id}`, options);
}; */